package io.writeopia.note_menu.ui.screen.file

actual fun fileChooserSave(title: String): String? = null